import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../../../services/authentication.service';
import { fadeAnimation } from '../../animations/animations';

/**
 * Home component
 */
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [fadeAnimation],
})
export class HomeComponent implements OnInit {
  /**
   * Constructor
   */
  constructor(private router: Router, private authenticationService: AuthenticationService, private route: ActivatedRoute) {}

  /**
   * ngOnInit
   */
  ngOnInit() {
    const firstRouteWithAccess = this.router?.config[0]?.children?.find((route) => {
      return this.authenticationService.isModuleAvailable(route.data?.module);
    });
    const url = firstRouteWithAccess ? firstRouteWithAccess.path : '';
    this.router.navigate([url]);

    console.log(this.route.snapshot.data.socket);
  }

  /**
   * Get router outlet state
   *
   * @param outlet Outlet
   */
  public getRouterOutletState(outlet): boolean | string {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }
}
